<template>
  <div class="renwu">
    <!-- 问卷列表 -->
    <div class="top">
      <Input v-model="naireNameTextLike" @on-clear="selectStatementRecordList(1)" @on-enter="selectStatementRecordList(1)" placeholder="请输入问卷名称进行搜索" clearable class="journal-input">
      <Icon type="ios-search" slot="prefix" />
      </Input>
      <Select class="select" placeholder="适用人群" clearable @on-clear="peopleChange" @on-change="peopleChange">
        <Option v-for="(item, index) in typeList" :value="item.value" :key="index">{{ item.name }}</Option>
      </Select>
      <Select class="select" placeholder="启用状态" clearable @on-clear="qiChange" @on-change="qiChange">
        <Option v-for="(item, index) in typeList2" :value="item.value" :key="index">{{ item.name }}</Option>
      </Select>
      <Select class="select" placeholder="是否必做" clearable @on-clear="biChange" @on-change="biChange">
        <Option v-for="(item, index) in typeList3" :value="item.value" :key="index">{{ item.name }}</Option>
      </Select>
      <Date-picker @on-change="datePicker" :options="options2" class="data" type="daterange" placeholder="选择创建日期"></Date-picker>
      <Date-picker @on-change="datePicker2" :options="options2" class="data" type="daterange" placeholder="选择修改日期"></Date-picker>
      <Button class="btn fourSize" type="success" @click="addItem" ghost>新增</Button>
      <Button class="btn fourSize" type="success" @click="asyncItem" ghost>同步</Button>
    </div>
    <div class="table-cont">
      <Table @on-sort-change="changesort" stripe @on-selection-change="selectChange" :columns="columns" :data="data"></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" :total="obj.count" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
    </div>

    <!-- 新增 修改弹框 -->
    <Modal class="ivumodal" footer-hide width="500" v-model="modify" :title="title">
      <div class="modal-cont">
        <Form ref="xiugai" :model="xiugai" :rules="xiugaidata" :label-width="150">
          <FormItem label="问卷名称：" prop="naireNameText" class="bumenModal-item">
            <Input v-model="xiugai.naireNameText" placeholder="请输入问卷名称" />
          </FormItem>
          <FormItem label="问卷介绍：" prop="intro" class="bumenModal-item">
            <Input v-model="xiugai.intro" type="textarea" :rows="4" placeholder="请输入问卷介绍" />
          </FormItem>
          <FormItem label="问卷图片：" prop="bgImg" class="bumenModal-item" :rules="{ required: true, message: '请上传图片' }">
            <div>
              <Upload :data="ImgData" :show-upload-list="false" ref="upload" :name="image" multiple :format="['jpg', 'jpeg', 'png', 'gif']" :on-success="successImg" :on-format-error="handleFormatErrorImg" :before-upload="handleBeforeUpload" :max-size="800" :on-exceeded-size="handleMaxSize" :action="actionUrl" style="display: inline-block;" v-show="uploadList.length < 1">
                <Button style="border-color:#53CAC3;color: #7F7F7F;" class="title-btn fourSize">上传图片</Button>
                <span class="modal-span">图片格式：jpg、png、gif、jpeg <br />
                  图片大小：小于 1 Mb</span>
              </Upload>
              <div class="upload-content">
                <div class="modal-img-cont">
                  <Icon type="ios-close-circle-outline" class="position" @click="clearImg()" v-show="xiugai.bgImg" />
                  <img class="modal-img-cont-img" :src="xiugai.bgImg" v-show="xiugai.bgImg" alt="" />
                </div>
              </div>
            </div>
          </FormItem>
          <FormItem label="适用人群：" prop="sex" class="bumenModal-item">
            <RadioGroup v-model="xiugai.sex">
              <Radio label="1">
                <span>男</span>
              </Radio>
              <Radio label="0" style="margin-left:50px;">
                <span>女</span>
              </Radio>
              <Radio label="2" style="margin-left:50px;">
                <span>全部</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="是否统计分值：" prop="countScore" class="bumenModal-item">
            <RadioGroup v-model="xiugai.countScore">
              <Radio label="1">
                <span>是</span>
              </Radio>
              <Radio label="0" style="margin-left:50px;">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="是否需要推荐：" prop="needAdvise" class="bumenModal-item">
            <RadioGroup v-model="xiugai.needAdvise">
              <Radio label="1">
                <span>是</span>
              </Radio>
              <Radio label="0" style="margin-left:50px;">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="是否必做：" prop="required" class="bumenModal-item">
            <RadioGroup v-model="xiugai.required">
              <Radio label="1">
                <span>是</span>
              </Radio>
              <Radio label="0" style="margin-left:50px;">
                <span>否</span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="可用状态：" prop="invisible" class="bumenModal-item">
            <RadioGroup v-model="xiugai.invisible">
              <Radio label="0">
                <span>启用</span>
              </Radio>
              <Radio label="1" style="margin-left:50px;">
                <span>停用</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Form>
        <div class="secondBumen-bottom">
          <Button class="btn" type="success" ghost @click="clear(1)">取消</Button>
          <Button class="btn sure" type="success" ghost @click="clear(2, 'xiugai')">确定</Button>
        </div>
      </div>
    </Modal>

    <!-- 删除弹框 -->
    <Modal class="ivumodal" v-model="sliceIBumen" title="删除" footer-hide>
      <div class="ivumodal-cont">
        删除后数据无法恢复，确认需要执行删除操作？ (建议改为停用状态)
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="sliceIBumencancel">取消</Button>
        <Button class="btn sure" type="success" ghost @click="sliceIBumencancel(1)">确定</Button>
      </div>
    </Modal>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
import {
  formatMoney,
  selectStatementRecordList,
  backNaire,
  postbackNaire,
  updateNaire,
  deleteNaire,
  getQuestionNaireSynchronization,
} from "../servers/api";
export default {
  name: "jiesuan",
  data() {
    return {
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      sliceIBumen: false,
      selectNum: 0,
      selectList: [],

      image: "image", //图片
      oldImgUrl: "", //图片
      actionUrl: "", //图片
      uploadList: [], //图片
      ImgData: {
        //图片
        imgType: "1",
      },
      xiugai: {
        sex: "2",
        naireNameText: "",
        invisible: "0",
        countScore: "0",
        needAdvise: "1",
        organizationId: "1",
        intro: "",
        required: "1",
        createUserId: "1",
        createUserName: "admin",
        bgImg: "",
      },
      modify: false,
      xiugaidata: {
        select: [
          {
            required: true,
            message: "请选择可用状态",
            trigger: "blur",
          },
        ],
        naireNameText: [
          {
            required: true,
            message: "请输入问卷名称",
            trigger: "blur",
          },
        ],
      },
      typeList2: [
        {
          name: "启用",
          value: "0",
        },
        {
          name: "停用",
          value: "1",
        },
      ], //select选择筛选
      typeList3: [
        {
          name: "是",
          value: "1",
        },
        {
          name: "否",
          value: "0",
        },
      ], //select选择筛选
      typeList: [
        {
          name: "全部",
          value: "2",
        },
        {
          name: "男",
          value: "1",
        },
        {
          name: "女",
          value: "0",
        },
      ], //select选择筛选
      options2: {
        shortcuts: [
          {
            text: "最近一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: "最近一个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: "最近三个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
      data: [],
      name: "可预约",
      background: "#fff",
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
        },
        {
          title: "问卷名称",
          width: 220,
          align: "center",
          key: "naireNameText",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "问卷介绍",
          width: 250,
          align: "center",
          key: "intro",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "使用人群",
          width: 110,
          align: "center",
          key: "sex",
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            let a = "";
            if (params.row.sex == "0") {
              a = "女";
            } else if (params.row.sex == "1") {
              a = "男";
            } else {
              a = "全部";
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    height: "25px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    "line-height": "30px",
                    color: "#7F7F7F",
                  },
                },
                a
              ),
            ]);
          },
        },
        {
          title: "统计分值",
          width: 110,
          align: "center",
          key: "countScore",
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            let a = "";
            if (params.row.countScore) {
              a = "是";
            } else {
              a = "否";
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    height: "25px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    "line-height": "30px",
                    color: "#7F7F7F",
                  },
                },
                a
              ),
            ]);
          },
        },
        {
          title: "推荐功能",
          width: 120,
          align: "center",
          key: "needAdvise",
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            let a = "";
            if (params.row.needAdvise) {
              a = "是";
            } else {
              a = "否";
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    height: "25px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    "line-height": "30px",
                    color: "#7F7F7F",
                  },
                },
                a
              ),
            ]);
          },
        },
        {
          title: "初次创建日期",
          align: "center",
          width: 140,
          ellipsis: true,
          sortable: true,
          key: "createTime",
          render: (h, params) => {
            let a = params.row.createTime;
            let num = "";
            if (a) {
              num = a.slice(0, 10);
            }

            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "创建人",
          width: 120,
          align: "center",
          key: "createUserName",
          ellipsis: true,
          sortable: true,
        },
        {
          title: "最后修改时间",
          align: "center",
          ellipsis: true,
          width: 140,
          sortable: true,
          key: "updateTime",
          render: (h, params) => {
            let a = params.row.updateTime;
            let num = "";
            if (a) {
              num = a.slice(0, 10);
            }

            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "最后修改人",
          align: "center",
          width: 130,
          ellipsis: true,
          sortable: true,
          key: "updateUserName",
        },
        {
          title: "删除",
          align: "center",
          width: 85,
          ellipsis: true,
          sortable: true,
          render: (h, params) => {
            return h("div", [
              h(
                "div",
                {
                  style: {
                    "text-align": "center",
                    cursor: "pointer",
                    color: "#53cac3",
                  },
                  on: {
                    click: () => {
                      this.clearItem(params.row);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
        {
          title: "操作/调整",
          key: "awssd",
          align: "center",
          width: 190,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "div",
                {
                  style: {
                    height: "27px",
                    display: "inline-block",
                    "line-height": "27px",
                    "text-align": "center",
                    "font-size": "13px",
                    border: "1px solid #53CAC3",
                    "border-radius": "5px",
                    width: "50px",
                    cursor: "pointer",
                    disabled: false,
                    color: "#7F7F7F",
                  },
                  on: {
                    click: () => {
                      this.posrTop(params.row);
                    },
                  },
                },
                "向上"
              ),
              h(
                "div",
                {
                  style: {
                    height: "27px",
                    display: "inline-block",
                    "line-height": "27px",
                    "text-align": "center",
                    "font-size": "13px",
                    border: "1px solid #53CAC3",
                    "border-radius": "5px",
                    width: "50px",
                    cursor: "pointer",
                    disabled: false,
                    color: "#7F7F7F",
                    "margin-left": "2px",
                  },
                  on: {
                    click: () => {
                      this.posrDown(params.row);
                    },
                  },
                },
                "向下"
              ),
              h(
                "div",
                {
                  style: {
                    width: "50px",
                    height: "27px",
                    "line-height": "27px",
                    "text-align": "center",
                    "font-size": "13px",
                    background: "#fff",
                    border: "1px solid #53CAC3",
                    "border-radius": "5px",
                    "margin-left": "2px",
                    cursor: "pointer",
                    display: "inline-block",
                    color: "#7F7F7F",
                  },
                  on: {
                    click: () => {
                      this.chengeTable(params.row);
                    },
                  },
                },
                "修改"
              ),
            ]);
          },
        },
      ],
      current: 1,
      pageSize: 20,
      obj: {},
      orderField: "",
      isAsc: "",
      receivedStartDate: "",
      receivedEndDate: "",
      orderField: "",
      isAsc: "",
      title: "新增",
      naireNameTextLike: "",
      sex: "",
      invisible: "",
      required: "",
      createTimeLeft: "",
      createTimeRight: "",
      updateTimeLeft: "",
      updateTimeRight: "",
      naireId: "",
    };
  },
  created() {
    this.selectStatementRecordList();
    this.actionUrl =
      sessionStorage.getItem("baseUrlWTS") + "/wts/oos/uploadimage";
  },
  methods: {
    clearItem(item) {
      this.sliceIBumen = true;
      this.naireId = item.naireId;
    },
    sliceIBumencancel(index) {
      if (index == 1) {
        deleteNaire({
          naireId: this.naireId,
        }).then((res) => {
          if (res.data.code == 10000) {
            this.sliceIBumen = false;
            this.selectStatementRecordList(1);
            this.isiconfontshow = false;
            this.alertTitleIshow = true;
            setTimeout(() => {
              this.alertTitleIshow = false;
            }, 2000);
          } else {
            this.isiconfontshow = false;
            this.alertTitle = res.data.msg;
            this.alertTitleIshow2 = true;
            setTimeout(() => {
              this.alertTitleIshow2 = false;
            }, 2000);
            this.obj = {};
            this.data = [];
          }
        });
      } else {
        this.sliceIBumen = false;
      }
    },
    posrTop(item) {
      //向上
      let obj = JSON.parse(JSON.stringify(item));
      obj.updown = "up";
      updateNaire(obj).then((res) => {
        if (res.data.code == 10000) {
          this.modify = false;
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.selectStatementRecordList(1);
        }
      });
    },
    posrDown(item) {
      //向下
      let obj = JSON.parse(JSON.stringify(item));
      obj.updown = "down";
      updateNaire(obj).then((res) => {
        if (res.data.code == 10000) {
          this.modify = false;
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.selectStatementRecordList(1);
        }
      });
    },
    clear(index, name) {
      //确定
      if (index == 2) {
        //确定
        this.$refs[name].validate((valid) => {
          if (valid) {
            if (this.xiugai.naireId !== "") {
              this.postupdateNaire();
            } else {
              this.postbackNaires();
            }
          }
        });
      } else {
        this.modify = false;
      }
    },
    postupdateNaire() {
      //修改
      updateNaire(this.xiugai).then((res) => {
        if (res.data.code == 10000) {
          this.modify = false;
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.selectStatementRecordList(1);
        }
      });
    },
    selectStatementRecordList(index) {
      //获取列表
      this.isiconfontshow = true;
      if (index) {
        this.current = 1;
      }
      let params = {
        naireNameTextLike: this.naireNameTextLike,
        sex: this.sex,
        invisible: this.invisible,
        required: this.required,
        createTimeLeft: this.createTimeLeft,
        createTimeRight: this.createTimeRight,
        updateTimeLeft: this.updateTimeLeft,
        updateTimeRight: this.updateTimeRight,
        page: this.current,
        limit: this.pageSize,
        orderField: this.orderField,
        isAsc: this.isAsc,
      };
      backNaire(params).then((res) => {
        if (res.data.code == 10000) {
          this.isiconfontshow = false;
          this.obj = res.data.data || {};
          this.data = res.data.data.naireList || [];
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
          this.obj = {};
          this.data = [];
        }
      });
    },
    postbackNaires() {
      //新建
      this.isiconfontshow = true;
      postbackNaire(this.xiugai).then((res) => {
        if (res.data.code == 10000) {
          this.modify = false;
          this.isiconfontshow = false;
          this.alertTitleIshow = true;
          setTimeout(() => {
            this.alertTitleIshow = false;
          }, 2000);
          this.selectStatementRecordList(1);
        }
      });
    },
    clearImg() {
      this.xiugai.bgImg = "";
    },
    successImg(response, file, fileList) {
      //上传图片成功后回调
      if (response.code == 1) {
        this.xiugai.bgImg = response.data.imgUrl;
      }
      this.xiugai = JSON.parse(JSON.stringify(this.xiugai));
    },
    peopleChange(e) {
      //使用人群
      if (e) {
        this.sex = e;
        this.selectStatementRecordList(1);
      } else {
        this.sex = "";
        this.selectStatementRecordList(1);
      }
    },
    qiChange(e) {
      //启用状态
      if (e) {
        this.invisible = e;
        this.selectStatementRecordList(1);
      } else {
        this.invisible = "";
        this.selectStatementRecordList(1);
      }
    },
    biChange(e) {
      //启用状态
      if (e) {
        this.required = e;
        this.selectStatementRecordList(1);
      } else {
        this.required = "";
        this.selectStatementRecordList(1);
      }
    },
    chengeTable(item) {
      //修改
      this.title = "修改";
      let obj = JSON.parse(JSON.stringify(item));
      if (item.countScore) {
        obj.countScore = "1";
      } else {
        obj.countScore = "0";
      }
      if (item.needAdvise) {
        obj.needAdvise = "1";
      } else {
        obj.needAdvise = "0";
      }
      // if (item.invisible) {
      obj.invisible = item.invisible + "";
      // } else {
      //   obj.invisible = "0";
      // }
      if (item.required) {
        obj.required = "1";
      } else {
        obj.required = "0";
      }
      obj.sex = item.sex + "";
      this.xiugai = obj;
      this.modify = true;
    },
    addItem() {
      //新增
      this.title = "新增";
      this.modify = true;
      this.xiugai.naireId = "";
      this.$refs["xiugai"].resetFields();
    },
    asyncItem() {
      getQuestionNaireSynchronization().then((res) => {
        if (res.data.code == 10000) {
          this.$Message.success("同步成功");
        }
      });
    },
    handleMaxSize(file) {
      this.$Message.success("请上传不超过800K的图片");
    },
    handleFormatErrorImg(file) {
      this.$Message.success("请选择jpg、jpeg、png、gif格式的图片上传");
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < 1;
      if (!check) {
        that.$Message.warning("最多上传1张图");
      }
      return check;
    },
    selectChange(item) {
      //表格select选中
      this.selectList = item;
      this.selectNum = this.selectList.length;
    },
    datePicker(data) {
      //时间搜索
      this.createTimeLeft = data[0];
      this.createTimeRight = data[1];
      this.selectStatementRecordList(1);
    },
    datePicker2(data) {
      //时间搜索
      this.updateTimeLeft = data[0];
      this.updateTimeRight = data[1];
      this.selectStatementRecordList(1);
    },
    changepeoplepage(num) {
      //换每页请求多少条
      this.pageSize = num;
      this.selectStatementRecordList(1);
    },
    changePeoplecurrent(num) {
      //换页
      this.current = num;
      this.selectStatementRecordList();
    },
    changesort(item) {
      //排序
      this.orderField = item.key;
      this.isAsc = item.order;
      this.current = 1;
      if (item.order == "normal") {
        this.isAsc = "";
        this.orderField = "";
      }
      this.selectStatementRecordList(1);
    },
  },
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.bumenModal-item {
  margin-top: 15px;
}

.modal-cont {
  width: 100%;
  max-height: 500px;
  overflow: hidden;
  overflow-y: visible;
  padding-bottom: 20px;
  padding-right: 20px;
}

.modal-img-cont {
  width: 100%;
  position: relative;
  border: 1px solid #53cac3;
  height: 120px;
  border-radius: 5px;
  margin-top: 10px;
}

.position {
  position: absolute;
  top: 5px;
  font-size: 25px;
  color: #53cac3;
  right: 5px;
  cursor: pointer;
}

.modal-img-cont-title {
  display: inline-block;
  height: 100%;
  width: 150px;
  line-height: 90px;
  vertical-align: top;
}

.modal-img-cont-img {
  display: inline-block;
  width: 150px;
  height: 105px;
  margin: 5px 15px;
}

.modal-num {
  width: 100%;
  text-align: right;
  color: #53cac3;
  line-height: 10px;
}

.modal-span {
  width: 178px;
  display: inline-block;
  line-height: 17px;
  vertical-align: middle;
}

.i-icon {
  font-size: 25px;
  font-weight: 700;
  line-height: 30px;
  vertical-align: middle;
  color: #53cac3;
  margin-left: 3px;
  cursor: pointer;
  display: inline-block;
}

.renwu {
  font-size: 13px;
  padding: 15px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  overflow-y: visible;
  .btn {
    float: right;
  }
  .top {
    width: calc(100% - 250px);
    height: 60px;
    line-height: 35px;
    position: fixed;
    top: 111px;
    z-index: 99;
    background: #fff;
    padding-top: 17px;
    left: 220px;
    padding-left: 15px;
    padding-bottom: 15px;
  }
  .select {
    width: 100px;
    // margin-right: 15px;
  }
  .journal-input {
    width: 180px;
    vertical-align: top;
  }
  .data {
    width: 190px;
    vertical-align: top;
  }
  .table-cont {
    padding-top: 40px;
    margin: 40px 0 60px;
  }
  .page-div {
    width: 100%;
    margin-top: 15px;
    position: fixed;
    background: #fff;
    width: calc(100% - 270px);
    height: 60px;
    z-index: 99;
    bottom: 0;
    padding-top: 15px;
    .page-div-left {
      float: left;
    }
    .page-div-page {
      float: right;
      margin-right: 15px;
    }
  }
  .title-btn {
    vertical-align: top;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/questions/questionlist.vue